export const ListUsers = [
  {
    user: 'sabri',
    password: '123',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto1',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 16,
  },
  {
    user: 'ponto2',
    password: 'abf',
    lotteryRule: 2,
    drawLimit: 11,
  },
  {
    user: 'ponto3',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 17,
  },
  {
    user: 'ponto4',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 17,
  },
  {
    user: 'ponto5',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 18,
  },
  {
    user: 'ponto6',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 17,
  },
  {
    user: 'ponto7',
    password: 'abf',
    lotteryRule: 2,
    drawLimit: 15,
  },
  {
    user: 'ponto8',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 19,
  },
  {
    user: 'ponto9',
    password: 'abf',
    lotteryRule: 2,
    drawLimit: 13,
  },
  {
    user: 'ponto10',
    password: 'abf',
    lotteryRule: 2,
    drawLimit: 15,
  },
  {
    user: 'ponto11',
    password: 'abf',
    lotteryRule: 2,
    drawLimit: 7,
  },
  {
    user: 'ponto12',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 18,
  },
  {
    user: 'ponto13',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto14',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto15',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto16',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto17',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto18',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto19',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto20',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto50',
    password: 'abf',
    lotteryRule: 2,
    drawLimit: 3,
  },
  {
    user: 'ponto60',
    password: 'abf',
    lotteryRule: 1,
    drawLimit: 2,
  },
  {
    user: 'ponto70',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto80',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto90',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  },
  {
    user: 'ponto100',
    password: 'abf',
    lotteryRule: 0,
    drawLimit: 0,
  }
]